import React, { useEffect, useState } from 'react'
import { no_image } from '../../Images';
const CountryFlag = (props) => {
    const [isValid, setIsValid] = useState(false);

    const { code, style } = props;
    const c = code == 'en' ? 'gb' : code;
    const url = `https://flagcdn.com/48x36/${c || 'id'}.png`;

    useEffect(() => {
        var s = document.createElement("IMG");
        s.src = url

        s.onload = function () {
            setIsValid(true);
        }
    }, [])

    return (
        <img src={isValid ? url : no_image} style={{ width: 30, height: 20, marginRight: 20, ...style }} />
    )
}

export default CountryFlag;